/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTieredChargeTableLookup.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/tiered-charge-table-lookup";

export class AutogenModelTieredChargeTableLookup<RowType extends ModelRow> extends Endpoint<RowType, RowTieredChargeTableLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTieredChargeTableLookup extends ModelRow<RowTieredChargeTableLookupFields> {
	constructor(values?: Partial<RowTieredChargeTableLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTieredChargeTableLookupFields {
	company_id: string;
	currency_type: string;
	descr: string;
	is_active: string;
	table_id: string;
}

